// The live "what's now" picture for the screens: trip clock and agenda, recomputed every minute
// (and when the app comes back into view).
import { useEffect, useMemo, useState } from 'react'
import type { Pack } from '../../shared/pack/schema'
import { buildAgenda, type AgendaItem } from '../domain/agenda'
import { tripClock, type TripClock } from '../domain/tripClock'

export function useMinuteClock(): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const tick = () => setNow(Date.now())
    let timer = setTimeout(function loop() {
      tick()
      timer = setTimeout(loop, 60_000 - (Date.now() % 60_000))
    }, 60_000 - (Date.now() % 60_000))
    const onVis = () => document.visibilityState === 'visible' && tick()
    document.addEventListener('visibilitychange', onVis)
    return () => {
      clearTimeout(timer)
      document.removeEventListener('visibilitychange', onVis)
    }
  }, [])
  return now
}

export interface TripNow {
  nowMs: number
  clock: TripClock
  /** Legs and plans in time order (the dock's Trip dot, map/journey todayNext). */
  agenda: AgendaItem[]
}

export function useTripNow(pack: Pack): TripNow {
  const nowMs = useMinuteClock()
  const agenda = useMemo(() => buildAgenda(pack.itinerary.legs, pack.itinerary.dayItems, pack), [pack])
  return useMemo(() => ({ nowMs, clock: tripClock(pack, nowMs), agenda }), [pack, nowMs, agenda])
}
